export default {
    namespaced: true,
    state: {
        logos: [
            'arcmet', 'agromat', 'mhp',
            'metinvest', 'shedro', 'agrosem',
            'budpostach', 'centra', 'eva', 'gs',
            'hc', 'rud', 'sirius', 'terra', 'tpk', 'ufc', 'varus'
        ]
    }
};

